import { useGetPlanList } from '@/features/store-management/premium-stores/hooks/useGetPlanList';
import { PlanManagementTable } from '@/features/store-management/premium-stores/planManagement/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const PlanManagementSearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),
  createdDate: z.string().optional(),
  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});
export const Route = createFileRoute('/(app)/store-information/premium-stores/plan-management/$clubid/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => PlanManagementSearchSchema.parse(search),
});

function RouteComponent() {
  const { data, pagination, isLoading, commonClubId } = useGetPlanList();
  return (
    <PlanManagementTable data={data || []} isLoading={isLoading} pagination={pagination} commonClubId={commonClubId} />
  );
}
